import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getTableEntries = (state, filter = null) => {
  if(filter === null) {
    filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
  }

  return filterObjectStore(state.table.tableEntries, filter);
};
